var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover tooltip-init",style:("background-image:url(" + _vm.url + ")"),attrs:{"data-tooltip":_vm.title},on:{"click":function($event){return _vm.addPerson(_vm.url)}}})}
var staticRenderFns = []

export { render, staticRenderFns }